import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
/**
 * 選定支援事例のリスト
 * @param props
 * @returns
 */
export const CaseList = (props) => {
    const { children, className = '' } = props;
    return (_jsx("ul", Object.assign({ className: clsx('grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3', 'gap-32', className) }, { children: children })));
};
